import { createArray } from "@/utils";
import { random } from "lodash";
import { AssociationUtils } from "../models/Federation";

type ContingentOffset = {
  nhoNumber: number;
  associations: number[];
  associationsText: string;
  contingentTotal: number;
  axTotal: number;
  difference: number;
  differenceAsPercentage: number;
  crmInvoice: any;
  contingentResponse: any;
  lastChanged?: string;
};

const randomItem = (): ContingentOffset => {
  const contingent = random(1000000, 10000000);
  const axContingent = random(1000000, 10000000);
  const difference = Math.abs(contingent - axContingent);
  const percentageDifference = Math.abs(contingent - axContingent);

  return {
    nhoNumber: random(10000, 99999),
    associations: AssociationUtils.randomList(),
    associationsText: AssociationUtils.randomList().join(" (Nelfo),"),
    contingentTotal: contingent,
    axTotal: axContingent,
    difference: difference,
    differenceAsPercentage: percentageDifference,
    crmInvoice: {},
    contingentResponse: {},
  };
};

const randomList = (max = 50): ContingentOffset[] =>
  createArray(random(20, max), randomItem);

const filterOffsets = (
  offsets: ContingentOffset[],
  filter: {
    nhoNumber: string;
    associations: string;
    contingentResponse: string;
  }
): ContingentOffset[] => {
  let filteredOffsets = offsets;
  const { nhoNumber, associations, contingentResponse } = filter;

  //FILTER nhoNumber
  if (nhoNumber !== "") {
    const nhoNumberTerms = getSearchTerms(nhoNumber);
    filteredOffsets = filteredOffsets.filter((offset: ContingentOffset) => {
      const fOrg = offset.nhoNumber.toString();
      return isMatchOnMultipleTerms(nhoNumberTerms, fOrg);
    });
  }

  //FILTER associations
  if (associations !== "") {
    const moTerms = getSearchTerms(associations);
    filteredOffsets = filteredOffsets.filter((offset: ContingentOffset) => {
      const fAssociations = offset.associationsText;
      return isMatchOnMultipleTerms(moTerms, fAssociations);
    });
  }

  //FILTER contingentResponse
  if (contingentResponse !== "") {
    const responseTerms = getSearchTerms(contingentResponse);
    filteredOffsets = filteredOffsets.filter((offset: ContingentOffset) => {
      const fContingentResponse = offset.contingentResponse.kontingent
        .map((kontingent: any) => kontingent.tekst)
        .join();
      return isMatchOnMultipleTerms(responseTerms, fContingentResponse);
    });
  }

  return filteredOffsets;
};

const isMatchOnMultipleTerms = (terms: string[], text: string): boolean => {
  return terms.every((term) => isSearchMatch(term, text));
};

const getSearchTerms = (searchText: string): string[] => {
  return searchText.split("&");
};

const format = (text: string): string => {
  return text.replaceAll(" ", " ").replaceAll("−", "-").toLowerCase().trim();
};

const isSearchMatch = (query: string, text: string): boolean => {
  if (query === "" || query === "!") return true;

  const isNegativeSearch = query.startsWith("!");

  if (isNegativeSearch) query = query.substring(1);

  query = format(query);
  text = format(text);

  return isNegativeSearch ? !text.includes(query) : text.includes(query);
};

export const ContingentOffsetDataUtils = {
  randomItem,
  randomList,
  filterOffsets,
};

export default ContingentOffset;
